import React from 'react'
import { NavLink } from 'react-router-dom'
// import contact from '../assets/pricing-table (7).webp'

const Contact = () => {
  return (
    <>
      <div className="container">
      <div className="row">
        <div className="col-md-3"></div>
        <div className="col-md-6">


        <section className="form-dark">

<div className="card card-image" >
    <div className=" py-5 px-5 z-depth-2">

        {/* <!--Header--> */}
        <div className="text-center">
            <h3 className=" mb-5 mt-4 font-weight-bold"><strong>CONTACT</strong> <NavLink className="green-text font-weight-bold"><strong> US</strong></NavLink></h3>
        </div>

        {/* <!--Body--> */}
        <div className="md-form text-warning">
            <input type="text" id="Form-email5" className="form-control white-text" />
            <label htmlFor="Form-email5 ">Your name</label>
        </div>

        <div className="md-form text-warning">
            <input type="text" id="Form-pass5" className="form-control" />
            <label htmlFor="Form-pass5">Your mail</label>
        </div>

        <div className="md-form mb-5 text-warning">
            <textarea type="text" id="message5" name="message5" rows="2" className="form-control md-textarea white-text"></textarea>
            <label htmlFor="message5">Your message</label>
            <div className="form-check">
                <input type="checkbox" className="form-check-input" id="checkbox7" />
                <label htmlFor="checkbox7" className="form-check-label white-text">Subscribe to our<NavLink to="#" className="green-text font-weight-bold"> newsletter?</NavLink></label>
            </div>
        </div>

        {/* <!--Grid row--> */}
        <div className="row d-flex align-items-center">

            {/* <!--Grid column--> */}
            <div className="text-center mb-3 col-md-12">
                <button type="button" className="btn btn-success btn-block btn-rounded z-depth-1 waves-effect waves-light">Send message</button>
            </div>
            {/* <!--Grid column--> */}

        </div>
        {/* <!--Grid row--> */}

    </div>
</div>

</section>


        </div>
        <div className="col-md-3"></div>

      </div>

      

      {/* <!--Header--> */}
      

      </div>
    </>
  )
}

export default Contact